import { useState } from 'react'
import * as S from './style'

interface IProps {
    activeStatus: (name: string) => void,
}

export default function FilterButtonLine({activeStatus}: IProps) {
    const [activeButton, setActiveButton] = useState('');

    const handleActive = (button: string) => {
        setActiveButton(button);
        activeStatus(button);
    };

    return (
        <S.Container>
            <S.Button
                isActive={activeButton === ''}
                onClick={() => handleActive('')}
            >
                Todos
            </S.Button>

            <S.Button
                isActive={activeButton === 'Pago'}
                onClick={() => handleActive('Pago')}
            >
                Pago
            </S.Button>

            <S.Button
                isActive={activeButton === 'Pendente'}
                onClick={() => handleActive('Pendente')}
            >
                Pendente
            </S.Button>
        </S.Container>
    )
}